<template>
  <div class="News">
    <basepanel>
    <!-- 企业新闻  行业动态 -->
      <el-tabs class="Tabs" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in news"
          :key="index"
          :label="item.title"
        >
          <div class="list">
            <div
              class="pan"
              v-for="(i, index) in item.list"
              :key="index"
              @click="goDetail(i.id)"
            >
              <div class="img">
                <img :src="i.defineUrl" alt="" />
              </div>
              <div class="txt">
                <div class="txt-box">
                  <p class="tit">{{ i.title }}</p>
                  <p class="publish-time">
                    {{ phoneshow ? "" : "发布时间：" }}
                    <!-- {{ i.publishTime.slice(0, 10) }} -->
                    {{ i.data.new_data }}

                  </p>
                </div>
                <p class="text">{{ i.data.htmleditor | handleText|ellipsis }}</p>
                <p class="more">
                  查看更多<i class="el-icon-d-arrow-right"></i>
                </p>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 分页 -->
      <div class="page">
        <el-pagination
          class="big-page"
          v-if="!phoneshow"
          @current-change="handleCurrentChange"
          :current-page="page[activeName].pageNumber"
          :page-size="page[activeName].pageSize"
          background
          layout="total, prev, pager, next, jumper"
          :total="page[activeName].total"
          :page-count="8"
        >
        </el-pagination>
        <el-pagination
          class="small-page"
          v-else
          small
          :page-count="8"
          layout="prev, pager, next"
          :total="page[activeName].total"
          @current-change="handleCurrentChange"
          :current-page="page[activeName].pageNumber"
          background
        ></el-pagination>
      </div>
    </basepanel>
  </div>
</template>
<script>
import basepanel from "../../components/BasePanel";
import { listNextWithFilter } from "../../api/index";
import local from "../../utils/local";
export default {
  components: { basepanel },
  data() {
    return {
      activeName: this.$route.query.switch ? this.$route.query.switch : "0",
      page: [
        {
          pageNumber: 1,
          pageSize: 10,
          total: 0,
        },
        {
          pageNumber: 1,
          pageSize: 10,
          total: 0,
        },
      ],
      news: [
        {
          title: "企业新闻",
          list: [],
        },
        {
          title: "行业动态",
          list: [],
        },
      ],
      map: [this.$map.newscategoryId, this.$map.news2categoryId],
      screenWidth: document.body.clientWidth,
    };
  },
  filters: {
    // 提出纯文本
    handleText: (str) => {
      let div = document.createElement("div");
      div.innerHTML = str;
      let text = div.innerText;
      div = null;
      return text;
    },
  },
  computed: {
    phoneshow: function () {
      return this.screenWidth <= 768 ? true : false;
    },
  },
  methods: {
    handleClick(tab) {
      this.getNews(tab.index);
    },
    handleCurrentChange(val) {
      let index = parseInt(this.activeName);
      this.page[index].pageNumber = val;
      this.getNews(index);
    },
    goDetail(id) {
      local.set("prePath", this.$route.name);
      this.$router.push("/detail/news/" + id);
    },
    async getNews(index) {
      let send = {
        url: {
          page: this.page[index].pageNumber,
          size: this.page[index].pageSize,
        },
        data: {
          categoryIdList: [this.map[index]],
          needData: true,
        },
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        let list = res.data;
        list.map((val) => {
          this.$set(val, "defineUrl", this.$srcHandle(val.data.imageclipper_1));
        });
        this.news[index].list = list;
        this.page[index].total = res.count;
      } else {
        console.log(res.msg);
      }
    },
  },
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    },
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    this.getNews(0); //企业新闻
    this.getNews(1); //行业动态
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/public.less";
.banner {
  width: 100%;
}
.News {
  background-color: #ffffff;
  /deep/ .el-tabs__nav-scroll {
    width: 100% !important;
    max-width: 1230px;
    margin: auto;
    .el-tabs__nav {
      width: 100%;
      .el-tabs__item {
        width: 50%;
        text-align: center;
        padding: 0;
        color: #666666;
        &:hover {
          color: #0e6cb6;
        }
      }
      .el-tabs__item.is-active {
        color: #0e6cb6;
      }
      .el-tabs__active-bar {
        width: 10% !important;
        left: 20%;
        background-color: #0e6cb6;
      }
    }
  }
  .list {
    height: 100%;
    // width: 86%;
    width: 92%;
    // max-width: 1500px;
    margin: 2vw auto auto;
    .pan {
      width: 100%;
      margin-bottom: 20px;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      cursor: pointer;
      &:hover {
        img {
          transform: scale(1.2);
        }
        .tit {
          color: #0e6cb6;
        }
        .text {
          color: #0e6cb6;
        }
        .more {
          color: #0875cb;
        }
      }
      .img {
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.5s ease;
        }
      }
      .txt {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        color: #333;
        // padding-left: 4%;
        // padding-left: 3vw;
        padding-left: 3%;
        // cursor: pointer;
        // &:hover {
        //   > .txt-box .tit {
        //     color: #0e6cb6;
        //   }
        //   > .text {
        //     color: #0e6cb6;
        //   }
        //   > .more {
        //     color: #0875cb;
        //   }
        // }
        .txt-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .tit {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 54%;
            letter-spacing: 2px;
          }
          .publish-time {
            letter-spacing: 1px;
            color: #999999;
            // font-size: 16px;
          }
        }
        .text {
          font-family: MicrosoftYaHeiLight;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          flex-direction: column;
          // text-indent: 2em;
          letter-spacing: 2px;
        }
        .more {
          // margin-left: auto;
          color: #666666;
          // margin-top: 55px;
        }
      }
    }
  }
  .page {
    .el-pagination {
      text-align: center;
    }
    .big-page {
      margin-top: 80px;
      margin-bottom: 100px;
    }
    .small-page {
      margin-top: 10px;
      margin-bottom: 20px;
    }
    /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #0875cb;
    }
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #0875cb;
      color: #ffffff;
    }
  }
}
@media screen and (min-width: 1200px) {
  /deep/ .el-tabs__nav-scroll {
    // line-height: 110px !important;
    line-height: 50px !important;
    padding-top: 30px;
    .el-tabs__item {
      font-size: 30px;
    }
  }
  .img {
    width: 440px;
    height: 248px;
  }
  .txt {
    width: ~"calc(97% - 440px)";
    .tit {
      font-size: 25px;
      line-height: 34px;
    }
    .publish-time {
      font-size: 16px;
    }
    .text {
      -webkit-line-clamp: 3;
      font-size: 20px;
      line-height: 32px;
      margin-top: 24px;
    }
    .more {
      font-size: 18px;
      margin-top: 25px;
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
  /deep/ .el-tabs__nav-scroll {
    // line-height: 80px!important;
    line-height: 50px !important;
    padding-top: 20px;
    .el-tabs__item {
      font-size: 24px;
    }
  }
  .img {
    width: 370px;
    // height: 260px;
    height: 208px;
  }
  .txt {
    width: ~"calc(97% - 370px)";
    .tit {
      font-size: 22px;
      line-height: 34px;
    }
    .publish-time {
      font-size: 16px;
    }
    .text {
      -webkit-line-clamp: 3;
      font-size: 18px;
      line-height: 26px;
      margin-top: 14px;
    }
    .more {
      font-size: 16px;
      margin-top: 20px;
    }
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  /deep/ .el-tabs__nav-scroll {
    line-height: 40px !important;
    .el-tabs__item {
      font-size: 18px;
    }
  }
  .img {
    width: 220px;
    // height: 150px;
    height: 124px;
  }
  .txt {
    width: ~"calc(97% - 220px)";
    .tit {
      font-size: 16px;
      line-height: 26px;
    }
    .publish-time {
      font-size: 12px;
    }
    .text {
      -webkit-line-clamp: 3;
      font-size: 12px;
      line-height: 20px;
      margin-top: 4px;
    }
    .more {
      font-size: 12px;
      margin-top: 10px;
    }
  }
}
@media screen and (max-width: 414px) {
  //phone
  /deep/ .el-tabs__nav-scroll {
    line-height: 30px !important;
    .el-tabs__item {
      font-size: 16px;
    }
  }
  .img {
    width: 130px;
    // height: 80px;
    height: 73px;
  }
  .txt {
    width: ~"calc(97% - 130px)";
    .tit {
      font-size: 15px;
      line-height: 26px;
      font-weight: bold;
    }
    .publish-time {
      font-size: 10px;
    }
    .text {
      -webkit-line-clamp: 2;
      font-size: 13px;
      line-height: 16px;
      margin-top: 2px;
    }
    .more {
      font-size: 10px;
      margin-top: 8px;
    }
  }
}
</style>